import { useState } from 'react'
import { CollectionMonitoringView } from '../../components/collections/CollectionMonitoringView'
import { CollectionRequestsView } from './case-collections-tab/CollectionRequestsView'
import { CollectionsTabBar, type CollectionsSubTab } from './case-collections-tab/CollectionsTabBar'

interface CaseCollectionsTabProps {
  caseId: string
}

export function CaseCollectionsTab({ caseId }: CaseCollectionsTabProps): React.ReactElement {
  const [activeSubTab, setActiveSubTab] = useState<CollectionsSubTab>('requests')
  const [expandRequestId, setExpandRequestId] = useState<string | null>(null)

  const handleNavigateToRequest = (requestId: string): void => {
    setExpandRequestId(requestId)
    setActiveSubTab('requests')
  }

  return (
    <div className="space-y-4">
      <CollectionsTabBar activeTab={activeSubTab} onTabChange={setActiveSubTab} />
      {activeSubTab === 'requests' && (
        <CollectionRequestsView
          caseId={caseId}
          expandRequestId={expandRequestId}
          onExpandHandled={() => {
            setExpandRequestId(null)
          }}
        />
      )}
      {activeSubTab === 'monitoring' && (
        <CollectionMonitoringView caseId={caseId} onNavigateToRequest={handleNavigateToRequest} />
      )}
    </div>
  )
}
